import * as types from '../types.js';
import obs_load_warehouses_create_outputs from '../types/obs_load_warehouses_create_outputs.js';

export default {

	html: `
		<style>
			#picking-wave-create.form {
				width: min(72rem, calc(100vw - 1.5rem));
				box-sizing: border-box;
			}
			#picking-wave-create #company_id,
			#picking-wave-create #warehouse_id,
			#picking-wave-create #customer_id,
			#picking-wave-create #route_id,
			#picking-wave-create #program_id,
			#picking-wave-create #reference { width: 100%; max-width: 100%; box-sizing: border-box; }
			#picking-wave-create .hint { font-size: 0.85rem; color: #444; margin: 0.35rem 0 0.75rem; }
			#picking-wave-create .pw-search {
				border: 1px solid #d1d5db;
				background: #f8fafc;
				padding: 0.65rem 0.75rem 0.35rem;
				margin: 0.5rem 0 0.75rem;
			}
			#picking-wave-create .pw-search .title-search {
				font-weight: 700;
				margin: 0 0 0.5rem;
				font-size: 0.95rem;
			}
			#pw-eligible { font-weight: 600; }
			#pw-selected { font-weight: 600; }
			#pw-orders {
				width: 100%;
				font-size: 0.85rem;
				max-height: min(28rem, 52vh);
				overflow: auto;
				display: block;
				border: 1px solid #e5e7eb;
			}
			#pw-orders table.view { width: 100%; }
			#pw-orders tr.pw-on td { background: #ecfdf5; }
			#pw-sim { white-space: pre-wrap; font-size: 0.85rem; max-height: 8rem; overflow: auto; }
			#picking-wave-create .pw-toolbar {
				display: flex;
				flex-wrap: wrap;
				gap: 0.5rem 0.75rem;
				align-items: center;
				margin: 0.4rem 0 0.6rem;
			}
		</style>
		<form id="picking-wave-create" class="form" autocomplete="off">
			<datalist id="pw-customers"></datalist>
			<datalist id="pw-routes"></datalist>
			<datalist id="pw-programs"></datalist>
			<div class="title">Nova onda de derrubada</div>
			<p class="hint">Pesquise os pedidos <strong>aprovados sem saída</strong>, marque os que entram no lote e gere a onda. Teto por lote na empresa (padrão 120). A derrubada só <strong>desce</strong> o palete — o operador escolhe o destino; não há devolução automática.</p>
			<div class="mtl fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<select id="company_id" required>
						<option value="">— Carregando empresas —</option>
					</select>
				</label>
				<label title="Armazém físico — só obrigatório se houver mais de um físico ativo">Armazém físico
					<select id="warehouse_id">
						<option value="">— Escolha a empresa primeiro —</option>
					</select>
				</label>
			</div>
			<div class="pw-search">
				<div class="title-search">Pesquisar pedidos</div>
				<div class="fsb">
					<label title="Número do pedido no SIAL (só dígitos, sem ponto)">Pedido
						<input id="order_id" type="text" inputmode="numeric" placeholder="ex.: 62094" autocomplete="off">
					</label>
					<label title="Referência / pedido do cliente">Referência
						<input id="reference" type="text" placeholder="contém">
					</label>
					<label title="Cliente (nome / razão social)">Cliente
						<input id="customer_id" type="text" list="pw-customers" placeholder="nome ou razão social">
					</label>
					<label title="Rota do cliente">Rota
						<input id="route_id" type="text" list="pw-routes" placeholder="código da rota">
					</label>
					<label title="Programa">Programa
						<input id="program_id" type="text" list="pw-programs" placeholder="nome">
					</label>
					<label title="Região (id; vazio = todas)">Região
						<input id="drs_id" type="text" inputmode="numeric" placeholder="id da região (opcional)">
					</label>
				</div>
				<div class="fsb">
					<label title="Criação a partir de">De
						<input id="date_from" type="date">
					</label>
					<label title="Criação até">Até
						<input id="date_to" type="date">
					</label>
					<label title="Previsão de entrega até">SLA até
						<input id="sla_to" type="date">
					</label>
				</div>
				<div class="ckb">
					<label><input id="is_emergency" type="checkbox" class="dib">&nbsp;Só emergenciais</label>
					<label><input id="include_expired" type="checkbox" class="dib">&nbsp;Incluir estoque expirado na simulação/geração</label>
				</div>
				<div class="pw-toolbar">
					<button class="button" type="button" id="pw-preview">Pesquisar</button>
					<button class="button" type="button" id="pw-clear-filters">Limpar filtros</button>
					<button class="button" type="button" id="pw-select-cap">Marcar até o teto</button>
					<button class="button" type="button" id="pw-clear-sel">Limpar seleção</button>
				</div>
				<p class="hint">
					Elegíveis nesta pesquisa: <span id="pw-eligible">—</span>
					&nbsp;·&nbsp; Selecionados: <span id="pw-selected">0</span>
				</p>
			</div>
			<div id="pw-orders"></div>
			<pre id="pw-sim" class="hint"></pre>
			<p class="hint"><strong>Simular</strong> só mostra o atendimento (não grava). <strong>Gerar onda</strong> cria a derrubada de verdade.</p>
			<div class="ckb">
				<label title="Confirmação — o diálogo seguinte também pede confirmação"><input id="confirm" type="checkbox" class="dib" checked>&nbsp;Confirmo a geração da derrubada</label>
			</div>
			<div class="mtm">
				<button class="bn_Escape button" type="button">Cancelar</button>
				<button class="button" type="button" id="pw-simulate">Simular</button>
				<button class="button" type="button" id="pw-generate">Gerar onda</button>
			</div>
		</form>
	`,

	form:
	{
		selector: '#picking-wave-create',
		init(formset)
		{
			formset.form.eraseValues();
			Object.getPrototypeOf(this).init.call(this);
		},
	},

	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub()] },
		{
			properties: { selector: '#warehouse_id' },
			types: [
				types.pubsub(),
				types.observer('company_id'),
				obs_load_warehouses_create_outputs(),
			],
		},
		{ properties: { selector: '#order_id' }, types: [] },
		{ properties: { selector: '#reference' }, types: [] },
		{
			properties: { selector: '#customer_id' },
			types: [
				types.pubsub(),
				types.datalist(),
				types.observer('company_id'),
				types.obs_load_options('customers', { labels: ['name'] }),
			],
		},
		{
			properties: { selector: '#route_id' },
			types: [
				types.pubsub(),
				types.datalist(),
				types.observer('company_id'),
				types.obs_load_options('customer_routes', { labels: ['code'] }),
			],
		},
		{
			properties: { selector: '#program_id' },
			types: [
				types.pubsub(),
				types.datalist(),
				types.observer('company_id'),
				types.obs_load_options('programs', { labels: ['name'] }),
			],
		},
		{ properties: { selector: '#drs_id' }, types: [] },
		{ properties: { selector: '#date_from' }, types: [] },
		{ properties: { selector: '#date_to' }, types: [] },
		{ properties: { selector: '#sla_to' }, types: [] },
		{ properties: { selector: '#include_expired' }, types: [types.checkbox()] },
		{ properties: { selector: '#is_emergency' }, types: [types.checkbox()] },
		{ properties: { selector: '#confirm' }, types: [types.checkbox()] },
	],
};
